import ApolloClient, {
  MutationOptions,
  OperationVariables,
  QueryOptions,
} from "apollo-client";

export class BaseDao {
  constructor(
    public gqlClient: (cached?: boolean) => Promise<ApolloClient<any>>,
  ) {}

  public updateClient(
    newClient: (cached?: boolean) => Promise<ApolloClient<any>>,
  ) {
    this.gqlClient = newClient;
  }

  headers: any;

  public setHeaders = (newHeaders) => {
    this.headers = newHeaders;
  };

  public addHeaders = (newHeaders) => {
    this.headers = {
      ...this.headers,
      ...newHeaders,
    };
  };

  protected async doQuery<T = any, TVariables = OperationVariables>(
    input: QueryOptions<TVariables>,
    cached = false,
    headers = {},
  ): Promise<T> {
    // experimental what happens

    let client = await this.gqlClient(cached);
    const context = {
      headers: { ...(this.headers || {}), ...(headers || {}) },
    };
    let results = await client.query({
      ...input,
      context,
    });
    if (results.errors) {
      const error = new Error(results.errors.map((e) => e.message).toString());
      error["serverErrors"] = results.errors;
      throw error;
    }
    return results.data;
  }

  protected async doMutate<T = any, TVariables = OperationVariables>(
    input: MutationOptions<T, TVariables>,
    cached = false,
  ): Promise<T> {
    let client = await this.gqlClient(cached);
    let results = await client.mutate(input);
    if (results.errors) throw new Error(JSON.stringify(results.errors));
    return results.data;
  }
}
